const getGlobal = <T = unknown>(globalName: string, namespace?: string): T | null => {
  if (namespace) {
    return (window as any)[namespace][globalName];
  }

  return (window as any)[globalName];
};

export default getGlobal;
